import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import type {
    AppsSearchRequestDto,
    AppsSearchResponseDto,
} from "app/pages/sales-intelligence/modules/apps-search/types/dto";
import { selectIsLeadsSearchDtoReady } from "app/pages/sales-intelligence/modules/leads-search";
import { useListParams } from "app/pages/sales-intelligence/modules/lists/context/ListParamsContext";

import { createAppsSearchResultsQuery } from "./options";

export function useAppsSearchResultsQuery<T = AppsSearchResponseDto>(
    dto: AppsSearchRequestDto,
    select?: (data: AppsSearchResponseDto) => T,
) {
    const listParams = useListParams();

    const isLeadsSearchDtoReady = useSelector(selectIsLeadsSearchDtoReady);

    return useQuery(createAppsSearchResultsQuery(dto, listParams, isLeadsSearchDtoReady, select));
}
